export default "__VITE_ASSET__24640eef__"